export default "__VITE_ASSET__73a1b3e3__"